import { CircularProgress } from '@material-ui/core'
import * as React from 'react'
import './style.scss'

function Circle() {
  return (
    <CircularProgress
      size="15em"
      classes={{
        circle: 'loader__circle',
        root: 'loader',
        colorPrimary: 'loader loader_primary'
      }}
    />
  )
}

export default Circle



// WEBPACK FOOTER //
// ./src/components/Circle/index.tsx